import { z } from "zod";

export const routeSchema = z.object({
  id: z.number(),
  date: z.string(),
  driver: z.object({
    name: z.string(),
  }),
  truck: z.object({
    id: z.number(),
    licence: z.string(),
    capacity: z.number(),
    title: z.string(),
    driver: z.object({
      id: z.number(),
      name: z.string(),
      username: z.string(),
    }),
  }),
});
